<template>
  <service
    :image="image"
    :position="imagePosition"
    :title="title"
  >
    <h1 class="hidden">{{title}}</h1>
    <p>
      From restaurant menu design to developing original recipes for brands and journals, or
      working with health practitioners to offer bespoke services for their clients, I am
      happy to collaborate!
    </p>
    <p>
      I am also available to speak at events and festivals, as well as run cooking demonstrations
      and workshops.
    </p>
    <p>
      If you have a project or event and are interested in collaborating, I would love to chat.
      I am contactable through email at
      <a href="mailto:contact@chefnaturelle.com">contact@chefnaturelle.com</a>.
    </p>
  </service>
</template>

<script>
import Service from '@/components/Service'
import MetaInfoBuilder from '@/utils/social'

export default {
  components: {
    Service,
  },
  computed: {
    imagePosition() {
      return 'center center'
    }
  },
  data: () => ({
    image: require(`@/assets/images/collaborations.jpg?vuetify-preload`),
    title: 'Collaborations',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description('Are you a yoga teacher or wellness professional looking for wholesome and nourishing food to'
        + ' complement your workshops and retreats?')
      .image(`${window.location.origin}${this.image.src}`)
      .title(this.title)
      .build()
  }
}
</script>

<style scoped>
h1 {
  color: #FF9300;
}
</style>
